// Banned.js
import React, { useEffect, useState } from "react";
import "./banned.css";

const Banned = ({ banExpiresAt, reason, appealCode }) => {
  const [timeState, setTimeState] = useState({
    d: "00", h: "00", m: "00", s: "00",
    isPermanent: false,
    isExpired: false
  });
  const [loadingPayment, setLoadingPayment] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date();
      const banTime = new Date(banExpiresAt);
      const diff = banTime - now;

      if (diff <= 0) {
        setTimeState({ d: "00", h: "00", m: "00", s: "00", isPermanent: false, isExpired: true });
        clearInterval(interval);
      } else {
        const days = Math.floor(diff / (24 * 3600 * 1000));
        
        // Catch permanent bans
        if (days > 3650) {
          setTimeState({ d: "00", h: "00", m: "00", s: "00", isPermanent: true, isExpired: false });
          clearInterval(interval);
          return;
        }

        const hours = Math.floor((diff % (24 * 3600 * 1000)) / (3600 * 1000));
        const minutes = Math.floor((diff % (3600 * 1000)) / (60 * 1000));
        const seconds = Math.floor((diff % (60 * 1000)) / 1000);
        
        setTimeState({
          d: String(days).padStart(2, '0'),
          h: String(hours).padStart(2, '0'),
          m: String(minutes).padStart(2, '0'),
          s: String(seconds).padStart(2, '0'),
          isPermanent: false,
          isExpired: false
        });
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [banExpiresAt]);

  const handlePayToUnban = async () => {
    if (!appealCode) return; 
    setLoadingPayment(true);
    
    try {
      const isProd = process.env.NODE_ENV === "production";
      const backendUrl = isProd ? "https://server-crimson-wildflower-4430.fly.dev" : "http://localhost:3000";

      const response = await fetch(`${backendUrl}/api/create-unban-checkout`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ uid: appealCode }),
      });

      const data = await response.json();
      if (data.url) {
        window.location.href = data.url; 
      } else {
        alert("Payment system temporarily unavailable.");
      }
    } catch (err) {
      console.error(err);
      alert("Error connecting to payment provider.");
    } finally {
      setLoadingPayment(false);
    }
  };

  const getFriendlyReason = (reason) => {
    if (reason === "Sexual") return "Sexually explicit content.";
    if (reason === "Hate") return "Hate speech or offensive gestures.";
    if (reason === "Violence") return "Violent or graphic content.";
    if (reason) return reason; 
    return "Violation of community guidelines.";
  };

  return (
    <div className="banned-split-overlay">
      <div className="banned-split-layout">
        
        {/* --- LEFT COLUMN: THE IMPACT --- */}
        <div className="banned-impact-section">
          <div className="impact-icon">🔒</div>
          <h1 className="impact-title">Account Suspended</h1>
          <p className="impact-message">
            Your account has been temporarily restricted for violating our community guidelines.
          </p>
        </div>

        {/* --- RIGHT COLUMN: THE ACTION --- */}
        <div className="banned-action-section">
          
          {/* Reason Block */}
          {reason && (
            <div className="action-block reason-block">
              <span className="block-label">Reason for Suspension</span>
              <p className="block-value">{getFriendlyReason(reason)}</p>
            </div>
          )}

          {/* Timer Block */}
          <div className="action-block timer-block">
            <span className="block-label">Access Restored In</span>
            {timeState.isPermanent ? (
              <div className="timer-elegant permanent-text">Permanent</div>
            ) : (
              <div className="timer-elegant">
                <span className="time-segment"><strong>{timeState.d}</strong> Days</span>
                <span className="time-separator">,</span>
                <span className="time-segment"><strong>{timeState.h}</strong> Hours</span>
                <span className="time-separator">,</span>
                <span className="time-segment"><strong>{timeState.m}</strong> Mins</span>
                <span className="time-separator">,</span>
                <span className="time-segment"><strong>{timeState.s}</strong> Secs</span>
              </div>
            )}
          </div>

          {/* Monetization Block */}
          <div className="express-unlock-card">
            <div className="express-header">
              <span className="express-title">Don't want to wait?</span>
            </div>
            <button 
              className="express-button"
              onClick={handlePayToUnban}
              disabled={loadingPayment || !appealCode}
            >
              {loadingPayment ? "Loading Secure Checkout..." : "Instant Unban - $1.99"}
            </button>
          </div>

          {/* Support & Appeal Block */}
          <div className="support-block">
            <p className="support-text">
              Think this was a mistake? Contact us at <a href="mailto:contact@talkvee.com">contact@talkvee.com</a>
            </p>
            {appealCode && (
              <div className="appeal-code-box">
                <span className="appeal-label">Appeal Code</span>
                <code className="appeal-value">{appealCode}</code>
              </div>
            )}
          </div>

          {/* Footer Links */}
          <div className="banned-footer-links">
            <a href="/terms" target="_blank" rel="noopener noreferrer">Terms</a>
            <span className="link-divider">|</span>
            <a href="/privacy" target="_blank" rel="noopener noreferrer">Privacy</a>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Banned;